import {
  DEFAULT_BREAKDOWN_COLUMNS_WIDTHS,
  BreakdownColumns,
} from "@repo/utils";

export const CELL_PADDING = 4;

export const CELL_HEIGHTS = {
  XXXSMALL: 18,
  XXSMALL: 24,
  XSMALL: 34,
  SMALL: 38,
  MEDIUM: 44,
  LARGE: 52,
  XLARGE: 56,
  XXLARGE: 64,
};

export const TIMELINE_MONTH_HEADER_HEIGHT =
  CELL_HEIGHTS.XXLARGE + CELL_HEIGHTS.XXXSMALL;

export const EXPAND_CELL_WIDTH = 42;
export const TIMELINE_BAR_BASE_HEIGHT = 36;
export const CELL_WIDTH_DEPTH_MODIFIER = 28;

export const CELL_WIDTHS = {
  VISIBILITY: 46,
  DRAG_HANDLE: 32,
  TITLE: DEFAULT_BREAKDOWN_COLUMNS_WIDTHS[BreakdownColumns.TITLE],
  DESCRIPTION: DEFAULT_BREAKDOWN_COLUMNS_WIDTHS[BreakdownColumns.DESCRIPTION],
  LABELS: DEFAULT_BREAKDOWN_COLUMNS_WIDTHS[BreakdownColumns.LABELS],
  LABELS_MIN: 90,
  TITLE_SMALLEST: 160,
  TITLE_SMALLER: 188,
  TITLE_NORMAL: 332,
  TITLE_LARGE: 432,
  TITLE_LARGEST: 640,
  TITLE_SUMMARY: 332,
  TITLE_BT_SUMMARY: 180,
  LAST_CELL_MODIFIER: 12,
  EXPAND: {
    DEPTH_0: EXPAND_CELL_WIDTH,
    DEPTH_1: EXPAND_CELL_WIDTH,
    DEPTH_2: EXPAND_CELL_WIDTH + CELL_WIDTH_DEPTH_MODIFIER,
    DEPTH_3: EXPAND_CELL_WIDTH + 2 * CELL_WIDTH_DEPTH_MODIFIER,
    DEPTH_4: EXPAND_CELL_WIDTH + 3 * CELL_WIDTH_DEPTH_MODIFIER,
  },
  VALUE: {
    XXSMALL: 82,
    XSMALL: 90,
    SMALL: 86,
    MEDIUM: 136,
    LARGE: 156,
    XLARGE: 172,
    XXLARGE: 228,
  },
  PRICE: {
    SMALL: 124,
    MEDIUM: 172,
    LARGE: 228,
  },
};

export const BAR_CHART_LINE_HEIGHTS = {
  BOUNDARIES: [2, 4, 6],
  WEIGHTS: [0.5, 0.7, 0.9],
};
